import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import './AppDescriptionPage.css';

interface AppDescriptionPageState {
  // Simple state matching reference project
}

interface AppDescriptionPageProps extends WithTranslation {
  navigate?: (path: string) => void;
}

// Simple interface for app description content
interface AppDescriptionContent {
  htmlContent: string;
}

class AppDescriptionPage extends Component<AppDescriptionPageProps, AppDescriptionPageState> {
  constructor(props: AppDescriptionPageProps) {
    super(props);
    this.state = {};
  }

  // Navigation method - Navigate back to settings
  goBack = () => {
    const { navigate } = this.props;
    if (navigate) {
      // Navigate back to settings page (reference project behavior)
      navigate('/settings');
    }
  };

  // App Description Content - Single HTML variable for easy management
  // EASY MANAGEMENT:
  // 1. Edit HTML directly in this string for content updates
  // 2. Copy/paste from HTML editor or Word (save as HTML)
  // 3. Replace entire string with CMS/database content
  // 4. Use template literals for dynamic values: ${variable}
  //
  // FUTURE DYNAMIC OPTIONS:
  // 1. Redux: this.props.appDescriptionContent?.htmlContent
  // 2. API: await this.props.getAppDescriptionContent()
  // 3. CMS: fetch from admin panel
  // 4. File: import from separate .html file
  getAppDescriptionContent = (): AppDescriptionContent => {
    const { t } = this.props;
    // Future: return { htmlContent: this.props.appDescriptionContent?.htmlContent || this.getDefaultContent() };
    return {
      htmlContent: `
        <p style="line-height: 20px;">
          ${t('app-description-screen:content')}
        </p>
      `
    };
  };

  render() {
    const { t } = this.props;
    const appDescriptionContent = this.getAppDescriptionContent();

    return (
      <div className="app-description-page">
        <div className="app-description-container">
          {/* Header - matching reference project structure */}
          <div className="page-header">
            <div className="page-header-inner">
              <div className="header-left">
                <button className="header-button back-button" onClick={this.goBack}>
                  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.79646 0.204319C6.07989 0.482194 6.07989 0.943465 5.80201 1.2269L2.42862 4.61141H15.2831C15.6777 4.61141 16 4.93374 16 5.33388C16 5.73402 15.6777 6.05635 15.2831 6.05635H2.42862L5.80757 9.44086C6.08545 9.72429 6.07989 10.18 5.80201 10.4634C5.51858 10.7413 5.06843 10.7413 4.78499 10.4579L0.205627 5.84517C0.144495 5.77848 0.0944773 5.70623 0.0555749 5.61731C0.0166725 5.52839 0 5.43391 0 5.33944C0 5.15048 0.0722476 4.97264 0.205627 4.8337L4.78499 0.220992C5.05731 -0.0679974 5.51303 -0.073555 5.79646 0.204319Z" fill="black"></path></svg>
                </button>
                <h1 className="header-title">
                    {t('app-description-screen:title')}
                  </h1>
              </div>
            </div>
          </div>

          {/* Content - Single HTML variable for easy management */}
          <div 
            className="app-description-content"
            dangerouslySetInnerHTML={{ __html: appDescriptionContent.htmlContent }}
          />
        </div>
      </div>
    );
  }
}

// Navigation wrapper component - matching reference project pattern
const AppDescriptionPageWithNavigation: React.FC<WithTranslation> = (props) => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <AppDescriptionPage
      {...props}
      navigate={handleNavigate}
    />
  );
};

// Redux connection matching reference project
const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AppDescriptionPageWithNavigation));
